import { render } from "./pageDangj.vue?vue&type=template&id=9e97b6da&scoped=true"
import script from "./pageDangj.vue?vue&type=script&lang=js"
export * from "./pageDangj.vue?vue&type=script&lang=js"

import "./pageDangj.vue?vue&type=style&index=0&id=9e97b6da&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e97b6da"]])

export default __exports__